import { render, staticRenderFns } from "./WideEduItem.vue?vue&type=template&id=1aa93212&scoped=true&"
import script from "./WideEduItem.vue?vue&type=script&lang=js&"
export * from "./WideEduItem.vue?vue&type=script&lang=js&"
import style0 from "./WideEduItem.vue?vue&type=style&index=0&id=1aa93212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa93212",
  null
  
)

export default component.exports